import { create } from 'zustand';

interface ChatUiState {
	hasMessages: boolean;
	setHasMessages: (value: boolean) => void;
}

export const useChatUiStore = create<ChatUiState>(set => ({
	hasMessages: false,
	setHasMessages: value => set({ hasMessages: value }),
}));

